<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style="border-radius: 5px !important; padding-left: 0px"
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-brand center>Air Freight Details</b-navbar-brand>

          <!-- <b-navbar-nav class="ml-auto">
            <b-nav-form>
              <b-button size="sm" variant="warning" @click="goToMain">New Client</b-button>
            </b-nav-form>
          </b-navbar-nav>-->
        </b-navbar>

        <!-- User Interface controls -->
        <div>
          <h5 class="text-muted pull-right mt-2 ml-3">
            <small>{{ totalRows }} Entries</small>
          </h5>
        </div>
        <div class="row">
          <div class="col-md-10">
            <b-form-group>
              <b-input-group>
                <b-form-input
                  :formatter="capitalizeAll"
                  v-model="filter"
                  placeholder="Type To Search"
                />
                <b-input-group-append>
                  <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </div>

          <div class="col-md-2">
            <model-list-select
              @input="viewFFExportFCL()"
              :list="dateStatusList"
              v-model="dateStatusFilter"
              option-value="inv"
              option-text="int"
              placeholder="Select Date Filter"
            ></model-list-select>
          </div>
        </div>
        <div class="table-responsive tableMain">
          <!-- Main table element -->
          <b-table
            show-empty
            stacked="md"
            :items="airFFData"
            :fields="fields"
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            @filtered="onFiltered"
          >
            <template slot="airFcExportId" slot-scope="row0">
              <span>{{ row0.index + 1 + (currentPage - 1) * perPage }}</span>
            </template>
            <template slot="clientNameAll" slot-scope="row01">
              <b>
                Client Name: {{ row01.item.clientNameAll }}
                <br />
              </b>
              <b>
                Cargo Weight: {{ row01.item.cargoGrossWeightAll }}
                <br />
              </b>
              <b v-if="row01.item.overSeaClientId != '0'">
                Overseas Agent: {{ row01.item.overseasAgent }}
                <br />
              </b>
            </template>
            <template slot="MAWBNumber" slot-scope="row11">
              <b>
                Flight Name: {{ row11.item.airlineName }}
                <br />
              </b>
              <b>
                Flight No: {{ row11.item.flightNumber }}
                <br />
              </b>
              <b>
                MAWB Number: {{ row11.item.MAWBNumber }}
                <br />
              </b>
            </template>
            <template slot="airFFExportSeries" slot-scope="row11">
              <div
                @click="
                  row11.item.is_locked == '1' &&
                  (row11.item.finalBillingCompleted == 1 ||
                    row11.item.locked_counter > 0) &&
                  $sessionsStorage.get('designation') != 'Admin' &&
                  $sessionsStorage.get('nameUser') != 'Bhavneesh'
                    ? ''
                    : viewExportAirPage(row11.item.airFcExportId)
                "
                class="showMoreData"
              >
                <!-- @click="viewExportAirPage(row11.item.airFcExportId)" class="showMoreData" -->
                <b>
                  <!-- {{row11.item}} -->
                  {{ row11.item.airFFExportSeries }}
                  <br />
                </b>

                <span>
                  Raised From : {{ row11.item.EmpLoc }}
                  <br />
                </span>
                <span>
                  Date : {{ row11.item.loginTime | moment }}
                  <br />
                </span>
              </div>
              <Assignment-Summary
                :title="'Shipment Summary Tracking - '"
                :fk_all_module_id="row11.item.allModuleId"
                :jb_series="row11.item.airFFExportSeries"
              />
              <b-button
                style="font-size: 0.675rem"
                class="mt-2"
                size="sm"
                @click="
                  row11.item.is_locked == '1' &&
                  (row11.item.finalBillingCompleted == 1 || row11.item.locked_counter > 0)
                    ? LockUnLock(row11.item, 'locked')
                    : ''
                "
                :variant="
                  row11.item.is_locked == '1' &&
                  (row11.item.finalBillingCompleted == 1 || row11.item.locked_counter > 0)
                    ? 'danger'
                    : 'success'
                "
                ><b
                  v-if="
                    row11.item.is_locked == '1' &&
                    (row11.item.finalBillingCompleted == 1 ||
                      row11.item.locked_counter > 0)
                  "
                  ><i class="fa fa-lock mr-1 lg"></i>LOCKED</b
                ><b v-else><i class="fa fa-unlock mr-1 lg"></i>UN-LOCKED</b></b-button
              ><br />
              <span v-if="row11.item.finalBillingCompleted == '1'"
                ><b :style="'color:black'">Billing : </b>
                <b-badge variant="success"><b>Completed</b></b-badge
                ><br
              /></span>
              <span v-if="row11.item.finalBillingCompleted == '0'"
                ><b :style="'color:black'">Billing : </b>
                <b-badge variant="danger"><b>Pending</b></b-badge
                ><br
              /></span>
            </template>
            <template slot="EmpLoc" slot-scope="row55">
              <!-- <b-button
                size="sm"
                @click="goToDoc(row55.item.airFcExportId)"
                variant="outline-info"
              >View Documents</b-button> -->
              <b-button
                size="sm"
                class="mt-2"
                style="font-size: 0.675rem"
                @click="showDocModal(row55.item)"
                variant="outline-info"
                >Summary & Documents</b-button
              >
              <Add-Message
                :fk_all_module_id="row55.item.allModuleId"
                style="list-style-type: none"
              />
              <!-- {{row55.item}} -->
              <Overseas-CRDRNote
                :title="row55.item.airFFExportSeries"
                :moduleType="'FF ' + row55.item.MS_transportType + ' Module'"
                :cr_all_module_id="row55.item.allModuleId"
                :cr_jb_series="row55.item.airFFExportSeries"
                :cr_ass_date="row55.item.loginTime | moment"
                :transportType="row55.item.MS_transportType"
                :Jobtype="'FF'"
                :commonId="row55.item.airFcExportId"
                :shipmentType="
                  row55.item.MS_shipmentType == '1' ||
                  row55.item.MS_shipmentType == 'Sea_Shipment'
                    ? 'Sea'
                    : 'Air'
                "
                :isOverseas="false"
                :ItemAr="null"
              />
              <MSDeleteRequest
                :item="row55.item"
                :JobNo="row55.item.airFFExportSeries"
                :JobID="row55.item.allModuleId"
                :sessionsStorage="$sessionsStorage"
                @refreshData="handleRefresh"
              />
              <b v-if="row55.item.deleteRequestBy != '' && row55.item.deleteRequestBy != '0' && row55.item.deleteRequestBy != null">Requested By : {{ row55.item.deleteRequestBy }}<br/></b>
              <b v-if="row55.item.deleteArrovedBy != '' && row55.item.deleteArrovedBy != '0' && row55.item.deleteArrovedBy != null">Arroved By : {{ row55.item.deleteArrovedBy }}<br/></b>
              
            </template>
          </b-table>
        </div>
        <b-row>
          <b-col md="12" class="my-1">
            <b-pagination
              limit="5"
              align="center"
              :total-rows="totalRows"
              :per-page="perPage"
              v-model="currentPage"
            />
          </b-col>
        </b-row>
      </b-card-text>
    </b-card>

    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop"
    ></md-dialog-confirm>
    <b-modal
      class="modal-dialog-doc"
      size="xl"
      no-close-on-esc
      no-close-on-backdrop
      ref="doc-modal"
      hide-footer
      :title="'Assignment Summary & Documents - ' + JOBSERIES"
    >
      <div v-if="ALLMODULE">
        <doc-form :allModuleIdProp="ALLMODULE" :JOBSERIES="JOBSERIES" />
      </div>
      <b-button class="mt-3" variant="outline-danger" block @click="hideDocModal"
        >Close
      </b-button>
    </b-modal>

    <!-- Added By Priyanshu Singh For Billing Close Section Start -->
    <b-modal
      id="modal-lock-conf"
      ref="modal-lock-conf"
      title="Reason for Open Locked Assignment"
      centered
      no-close-on-esc
      no-close-on-backdrop
      hide-footer
    >
      <h3>Confirmation</h3>
      <form ref="form">
        <b-form-group
          label="Remark"
          label-for="name-input"
          invalid-feedback="Name is required"
        >
          <b-form-textarea
            :formatter="capitalizeAll"
            rows="5"
            id="name-input"
            v-model="lockReason"
            required
          ></b-form-textarea>
        </b-form-group>
      </form>
      <b-button @click="closeLockUnLockConfirm" variant="danger"> Cancel</b-button>
      <b-button
        v-if="lockReason"
        :disabled="lock_button ? true : false"
        variant="success"
        class="pull-right"
        @click="ConfLock"
        >Send</b-button
      >
    </b-modal>
    <!-- Added By Priyanshu Singh For Billing Close Section End -->
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import DatePicker from "vue2-datepicker";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import { globalPermissionStatus } from "../../helper/collection";
import DocForm from "../allModuleForm/docLibrary.vue";
import AddMessage from "../../component/allModuleForm/addMessage.vue";
import AssignmentSummary from "../../component/common/assignmentSummary.vue";
import OverseasCRDRNote from "../common/overseasCRDRNote.vue";
import CustomLoader from "../common/customLoader.vue";
import { ModelListSelect } from "vue-search-select";
import MSDeleteRequest from "../common/MSDeleteRequest.vue";

export default {
  beforeMount() {
    if (globalPermissionStatus("Air Freight")) {
      this.$store.dispatch("setCurrentRoute", "/airFreight/viewAirFF");

      this.viewFFExportFCL();
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },

  data() {
    return {
      lock_allModuleId: "",
      lock_ffExportFclId: "",
      lock_ffExportFclSeries: "",
      lock_Type: "",
      lockReason: "",
      is_locked: "",
      locked_counter: "",
      lock_button: false,

      ALLMODULE: "",
      JOBSERIES: "",
      fields: [
        {
          key: "airFcExportId",
          label: "Sr No.",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "airFFExportSeries",
          label: "Assignment No.",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "clientNameAll",
          label: "Client Name",
          sortable: true,
          sortDirection: "desc",
        },

        {
          key: "MAWBNumber",
          label: "Flight No/ MAWB Number",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "departureAirport",
          label: "Departure Airport",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "destinationAirport",
          label: "Destination Airport",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "EmpLoc",
          label: "",
          sortable: true,
          sortDirection: "desc",
        },
      ],
      currentPage: 1,
      perPage: 10,
      totalRows: "",
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      sortDirection: "desc",
      filter: null,
      modalInfo: { title: "", content: "" },
      isLoading: false,
      alert: {
        content: "Are you sure you want to delete ..!",
        ok: "ok",
      },

      airFFData: [],

      dateStatusFilter: "60",
      dateStatusList: [
        {
          inv: "60",
          int: "2 Month",
        },
        {
          inv: "90",
          int: "3 Month",
        },
        {
          inv: "125",
          int: "4 Month",
        },
        {
          inv: "186",
          int: "6 Month",
        },
        {
          inv: "248",
          int: "8 Month",
        },
        {
          inv: "300",
          int: "10 Month",
        },
        {
          inv: "367",
          int: "1 Year",
        },
        {
          inv: "734",
          int: "2 Year",
        },

        {
          inv: "0",
          int: "Global ALL",
        },
      ],
    };
  },

  mounted() {},
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  beforeDestroy() {},

  destroyed() {},

  components: {
    Loading,
    DocForm,
    AddMessage,
    AssignmentSummary,
    OverseasCRDRNote,
    CustomLoader,
    ModelListSelect,
    MSDeleteRequest,
  },

  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },
  },

  methods: {
    ConfLock() {
      if (this.lockReason) {
        this.isLoading = true;
        let tit = "";
        if (this.is_locked == 1) {
          this.is_locked = "0";
          tit = "Un-Locked";
        } else if (this.is_locked == 1) {
          this.is_locked = "1";
          tit = "Locked";
        }
        this.lock_button = true;
        let payload = {
          allModuleId: this.lock_allModuleId,
          lockReason: this.lockReason,
          update_keyVal: this.lock_ffExportFclId,
          assigmnmentSeries: this.lock_ffExportFclSeries,
          Type: this.lock_Type,
          is_locked: this.is_locked,
          locked_counter: this.locked_counter,
          table_name: "air_freightexport",
          update_key: "airFcExportId",
          Title: tit,
          module_type: "FF Air Export",
        };
        // return false;
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Common/locknnlockStatus.php`,
          data: JSON.stringify(payload),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              if (data.find == 1) {
                this.alert.content = data.MSG;
              } else {
                this.alert.content = data.MSG;
              }
              this.$refs["addPop"].open();
              this.lock_button = false;
              this.viewFFExportFCL("0", "1", "1");
              this.isLoading = false;
            }
            (this.lockReason = ""), this.$refs["modal-lock-conf"].hide();
          })
          .catch((error) => {});
      }
    },
    LockUnLock(items, type) {
      this.lock_allModuleId = items.allModuleId;
      this.lock_ffExportFclId = items.airFcExportId;
      this.lock_ffExportFclSeries = items.airFFExportSeries;
      this.lock_Type = type;
      this.is_locked = items.is_locked;
      this.locked_counter = items.locked_counter;
      console.log("Priyanshu Singh=>", items);
      // return false;
      this.$refs["modal-lock-conf"].show();
    },
    closeLockUnLockConfirm() {
      this.$refs["modal-lock-conf"].hide();
    },

    showDocModal(item) {
      this.ALLMODULE = "";
      this.JOBSERIES = "";
      this.ALLMODULE = item.allModuleId;
      this.JOBSERIES = item.airFFExportSeries;
      console.log(this.ALLMODULE);
      console.log(this.JOBSERIES);
      this.$refs["doc-modal"].show();
    },
    hideDocModal() {
      this.$refs["doc-modal"].hide();
    },
    gotoDocs(item) {
      this.$router.push({
        path: "/allModule/docs/" + item,
      });
    },
    goToDoc(ID) {
      this.$router.push({
        path: "/freightForwarding/ffDocListPage/" + ID + "/AirExport",
      });
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    goToMain() {
      this.$sessionsStorage.set("editffAirExport", "");
      this.$router.push({
        path: "/airFreight/airFFExportConsol",
      });
    },
    JqueryFun() {
      return $(function () {
        return $("#conBooking").DataTable();
      });
    },

    viewExportAirPage(FCLAir) {
      this.$sessionsStorage.set("editffAirExport", FCLAir);

      this.$router.push({
        path: "/airFreight/airFFExportConsol",
      });
    },
    handleRefresh() {
      this.viewFFExportFCL("0", "0", "1", "1");
    },
    viewFFExportFCL() {
      this.isLoading = true;
      let payload = {
        view: "view",
        dateStatusFilter: this.dateStatusFilter,
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_AirExport/viewFFAirExportList.php`,
        data: JSON.stringify(payload),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            if (data.AirExportDetails.length > 0) {
              console.log(data);
              this.airFFData = data.AirExportDetails;
              this.totalRows = data.AirExportDetails.length;
            }
            this.isLoading = false;
            this.JqueryFun();
          }
        })
        .catch((error) => {});
    },
  },
};
</script>
<style></style>



// WEBPACK FOOTER //
// viewAirFF.vue?196c865f